import React from 'react';
import { cn } from '../../../utils/cn';

const UnreadBadge = ({ count = 0, className }) => {
  const value = Number(count) || 0;
  if (value <= 0) return null;

  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-[1.25rem] shrink-0 items-center justify-center rounded-full bg-orange-500 px-1 text-xs font-semibold leading-none text-white',
        className
      )}>
      {value > 99 ? '99+' : value}
    </span>
  );
};

export default UnreadBadge;
